import { Component, OnInit, Inject } from '@angular/core';

import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { QuestionnaireService } from '@shared/services/questionnaire.service';
import { SharedDataService } from '@shared/services/shared-data.service';
import { InsertQuestionDialogComponent } from './dialogs/insert-question-dialog/insert-question-dialog.component';

@Component({
  selector: 'db-custom-field-radio-dialog',
  templateUrl: './editor-dialog.component.html',
  styleUrls: ['./editor-dialog.component.scss']
})
export class EditorDialogComponent implements OnInit {
  editor: any;
  tinyMceConfig: any;
  checkIsLockDownEdit: any;
  model: any = {};
  id: string;
  userPermission: any;

  insertQuestionDialogRef: MatDialogRef<InsertQuestionDialogComponent>;

  constructor(
    private dialog: MatDialog,
    private editorDialogRef: MatDialogRef<EditorDialogComponent>,
    private questionnaireService: QuestionnaireService,
    private sharedDataService: SharedDataService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  ngOnInit() {
    this.id = this.data.field.model.id;
    this.model = this.data.field.model;
    this.userPermission = this.sharedDataService.userIsAdmin;
    this.checkIsLockDownEdit = this.data.field.isLockDownEdit;
    this.editorDialogRef.updateSize('900px');
    this.configureTinyMce();
  }

  configureTinyMce() {
    this.tinyMceConfig = {
      auto_focus: true,
      base_url: '/tinymce',
      branding: false,
      height: 400,
      image_advtab: true,
      imagetools_toolbar: `
        rotateleft rotateright |
        flipv fliph |
        editimage imageoptions`,
      importcss_append: !0,
      menubar: false,
      paste_data_images: !0,
      skin: 'oxide',
      plugins: [
        'advlist lists link image directionality',
        'searchreplace visualblocks visualchars media table contextmenu paste textcolor colorpicker pagebreak code',
        'table'
      ],
      codesample_languages: [
        {text: 'HTML/XML', value: 'markup'}
      ],
      toolbar: `
        copy undo redo formatselect |
        bold italic strikethrough forecolor backcolor |
        link |
        alignleft aligncenter alignright alignjustify |
        numlist bullist outdent indent |
        removeformat hr pagebreak code |
        table tabledelete | tableprops tablerowprops tablecellprops | tableinsertrowbefore tableinsertrowafter tabledeleterow | tableinsertcolbefore tableinsertcolafter tabledeletecol`,
      setup: (editor) => {
        this.editor = editor;

        if (this.checkIsLockDownEdit && !this.userPermission) {
          editor.settings.readonly = true;
        } 
        if (this.userPermission) {
          editor.settings.readonly = false;
        }
      },
      images_upload_handler: function (e: any, t: any, a: any) {
        t('data:' + e.blob().type + ';base64,' + e.base64());
      }
    };
  }

  insertQuestion() {
    this.insertQuestionDialogRef = this.dialog.open(InsertQuestionDialogComponent, {
      panelClass: 'db-dialog',
      width: '600px'
    });

    this.insertQuestionDialogRef.afterClosed()
      .subscribe(data => {
        if (data) {
          this.editor.insertContent(data);
        } else {
          return;
        }
      });
  }

  closeDialog() {
    this.editorDialogRef.close();
  }
}
